export const commonPopupDisplay = (message:any, setPopupcontent:any, Popupcontent:any, titleImg:any, titleText:any, outlineBtnFunc: any) => {
  let decriptionTxt = (
    <div>
        <p>{message}</p>
    </div>
  );
  setPopupcontent({
      ...Popupcontent,
      titleImg: titleImg,
      title: titleText,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        outlineBtnFunc();
      }
  });
}